/**
 * @module builder
 */

type StatusOption = {
  value: string
  label: string
  primary?: boolean
  feature?: string
}

export const QUOTE_STATUS_OPTIONS = [
  { value: 'draft', label: 'Draft', primary: true },
  { value: 'sent', label: 'Sent', primary: true },
  { value: 'onHold', label: 'On Hold', primary: true },
  { value: 'viewed', label: 'Viewed', primary: true },
  { value: 'accepted', label: 'Accepted', primary: true },
  { value: 'declined', label: 'Declined', primary: true },
  { value: 'invoiced', label: 'Invoiced' }
]
export const INVOICE_STATUS_OPTIONS = [
  { value: 'draft', label: 'Draft', primary: true },
  { value: 'sent', label: 'Sent', primary: true },
  { value: 'viewed', label: 'Viewed', primary: true },
  { value: 'partial', label: 'Partial', primary: true },
  { value: 'paid', label: 'Paid', primary: true }
]

export function getStatusOptions(args?: {
  isInvoice?: boolean
  all?: boolean
  allowInvoiced?: boolean
}): StatusOption[] {
  const { isInvoice, all, allowInvoiced = true } = args ?? {}
  if (all) {
    return [...QUOTE_STATUS_OPTIONS, ...INVOICE_STATUS_OPTIONS].filter(
      (option) => allowInvoiced || option.value !== 'invoiced'
    )
  } else if (isInvoice) {
    return INVOICE_STATUS_OPTIONS
  } else {
    return QUOTE_STATUS_OPTIONS.filter((option) => allowInvoiced || option.value !== 'invoiced')
  }
}
